import {Modal} from 'react-bootstrap';
import React, { useContext, useState } from 'react';
import { UserContext } from '../../Contexts/UserContext';
import { eventService } from '../../Services/eventService';
import toast from 'react-hot-toast';

const EditGeoJsonModal = (props) => {
    const { geoJsonTypes } = useContext(UserContext);
    const [geoJson, setGeoJson] = useState(props.geoJson ?? {
        name: '',
        geoJsonTypeId: geoJsonTypes[0].geoJsonTypeId,
        sequenceNo: 1
    });
    const [file, setFile] = useState(null);

    const handleFileChange = (event) => {
        if (event.target.files[0]) {
            setFile(event.target.files[0]);
        } else {
            setFile(null);
        }
    };

    const save = () => {
        if(props.geoJson != null) {
            eventService.updateGeoJson(props.geoJson.eventGeoJsonId, geoJson.name, geoJson.geoJsonTypeId, geoJson.sequenceNo, file).then((e) => {
                toast.success("Updated Geo Json successfully");
                props.setShow(false);
                props.reload();
            }).catch((e) => {
                console.log(e);
                toast.error("Unable to update Geo Json");
            });
        } else {
            if(file == null) {
                toast.error("Please upload a file");
                return;
            }
            eventService.addGeoJson(props.eventId, geoJson.name, geoJson.geoJsonTypeId, geoJson.sequenceNo, file).then((e) => {
                toast.success("Uploaded Geo Json successfully");
                props.setShow(false);
                props.reload();
            }).catch((e) => {
                console.log(e);
                toast.error("Unable to upload Geo Json");
            });
        }
    };

    return (
            <Modal
                show={() => props.setShow(true)}
                onHide={() => props.setShow(false)}
                backdrop="static"
                keyboard={false}
                dialogClassName=""
                className="member-edit-modal"
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        <h5>Add/Edit GeoJsons</h5>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <div>Name: <input type="text" value={geoJson?.name} onChange={(e) => setGeoJson({...geoJson, name: e.target.value})}/></div>
                        <div>Sequence No: <input type="text" value={geoJson?.sequenceNo} onChange={(e) => setGeoJson({...geoJson, sequenceNo: e.target.value})}/></div>
                        <div>
                            Layer: <select className="form-select" onChange={(e) => setGeoJson({...geoJson, geoJsonTypeId: e.target.value})} value={geoJson?.geoJsonTypeId}>
                                {
                                    geoJsonTypes.map((g) => {
                                        return <option value={g.geoJsonTypeId}>{g.name}</option>
                                    })
                                }
                            </select>
                        </div>
                        <div>
                            GeoJson: <input type="file" className="upload-input" onChange={handleFileChange} accept=".geojson" />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-outline" onClick={() => props.setShow(false)}>CANCEL</button>
                    <button type="button" className='btn btn-primary ml-auto submit-btn' onClick={()=>save()}>SAVE</button>
                </Modal.Footer>
            </Modal>
    );
}

export default EditGeoJsonModal;